import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import { INotificationMessage } from 'store/modules/notifications';
import { NotificationMessage } from '../../presentational/application';
import { IRootState } from 'store/modules';
import * as App from 'application';


const mapStateToProps = (state: IRootState) => ({
	messages: App.Operation.getUserNotifications(state),
	isShowing: (App.Operation.getUserNotifications(state).length > 0)
});

const mapDispatchToProps = (dispatch: Redux.Dispatch) => ({
	onClose: () => App.Operation.clearUserMessages(dispatch),
});

interface INotificationHandlerProps {
	messages: INotificationMessage[];
	onClose(): void;
}

const NotificationHandlerComponent: React.SFC<INotificationHandlerProps> = (props) => {
	if (props.messages === undefined || props.messages.length === 0) {
		return null;
	}
	const result = props.messages.map((val, index) => <NotificationMessage key={index} type={val.type} title={val.title} details={val.details} onHide={props.onClose} />);
	return (<div>{result}</div>);
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationHandlerComponent);



// WEBPACK FOOTER //
// ./src/components/containers/handlers/NotificationHandler.tsx